import { ApplePayPaymentButton } from "../../../applePay/components/applePayPaymentButton.component";
import { useApplePayReducedForm } from "../../../hooks/useApplePayReducedForm";
import { GooglePayActionButton } from "../../../googlePay/components/googlePayActionButton.component";

import { digitalWallets } from "../../types/digitalWallets.types";

export const DigitalWalletPaymentButton = ({
  digitalWallet,
  isValidFields,
}: {
  digitalWallet: digitalWallets;
  isValidFields: boolean;
}) => {
  const isApplePayReducedForm = useApplePayReducedForm();
  const digitalWallets = {
    clickToPay: () => null,
    applePay: () => <ApplePayPaymentButton isValid={isApplePayReducedForm ? isValidFields : true} />,
    googlePay: () => <GooglePayActionButton isValid={isValidFields}/>,
  };
  return digitalWallet && digitalWallets[digitalWallet]();
};
